import { convertDate } from "../../../utils";

export const reminderObject = {
  broadcastID: "",
  stagesCount: 0,
  segmentID: "",
  templateID: [],
};

export function objectFromResponseData(responseData, templateData) {
  let object = {};

  responseData.stages.forEach((item) => {
    let templateName = templateData.filter((i) => item.template_id == i?._id)[0]
      ?.name;

    var [day, month, year] = item?.schedule_date?.split("-");

    var formattedDate = `${year}-${month}-${day}`;

    object[templateName] = {
      templateID: item?.template_id,
      broadcastDate: formattedDate,
      broadcastTime: item?.schedule_time.time,
      ...(item.header_variable?.length && {
        header_variable: item.header_variable?.map((headerVariableValue) => {
          return {
            variable_default_value: headerVariableValue.variable_default_value,
            variable_name: headerVariableValue.variable_name,
            variable_value: headerVariableValue.variable_value,
            file_name: headerVariableValue.file_name,
            variable_value_type: headerVariableValue.variable_value_type,
          };
        }),
      }),
      ...(item?.body_variable?.length && {
        body_variable: item?.body_variable.map((bodyVariableValue) => {
          return {
            variable_default_value: bodyVariableValue.variable_default_value,
            variable_name: bodyVariableValue.variable_name,
            variable_value: bodyVariableValue.variable_value,
            variable_value_type: bodyVariableValue.variable_value_type,
          };
        }),
      }),
      ...(item?.button_variable?.length && {
        button_variable: item?.button_variable.map((buttonVariableValue) => {
          return {
            variable_default_value: buttonVariableValue.variable_default_value,
            variable_name: buttonVariableValue.variable_name,
            variable_value: buttonVariableValue.variable_value,
            variable_value_type: buttonVariableValue.variable_value_type,
          };
        }),
      }),
    };
  });

  return {
    broadcastName: responseData.broadcast_name,
    broadcastID: responseData._id,
    stagesCount: responseData.stages_count,
    segmentID: responseData.segment_id,
    createdAt: convertDate(responseData.created_at),
    createdBy: responseData.created_by,
    leadsFile: responseData.leads_file_url,
    templateID: responseData.stages.map((item) => item.template_id),
    segmentFilter: responseData.segment_filter,
    segmentName: responseData.segment_name,
    segmentLabels: responseData.labels,
    ...object,
  };
}
